import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Cubic, Expo } from 'gsap'
import SplitText from 'utils/gsapPlugins/SplitText.min'

import Scroller from 'src/utils/scroller'
import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'

import ImgItem from './components/img-item'

export default class WallWrapperMobile extends Component {
  constructor(props) {
    super(props)

    this.currentWall = 0

    this.defaultItems = 6

    this.state = {
      itemsPerScreen: this.defaultItems
    }

    this.key = 'wallWrapperMobile'
  }

  componentDidMount() {
    Scroller.updateScrollHeight()
  }

  componentDidUpdate() {
    Scroller.updateScrollHeight()
  }

  onClick = () => {
    this.setState({
      itemsPerScreen: (this.state.itemsPerScreen += this.defaultItems)
    })
  }

  render() {
    return (
      <div ref="component" className="component m-wall-wrapper">
        <div className="wall-main-wrapper" ref="wallMainWrapper">
          {this.props.items.map((item, i) => {
            return i < this.state.itemsPerScreen ? (
              <ImgItem key={`img${i}`} ref={`img${i}`} data={item} />
            ) : null
          })}
        </div>

        {this.defaultItems < this.props.items.length - 1 && (
          <div onClick={this.onClick} className="main-btn-container">
            <div className="btn-container">
              <span ref="tLine" className="line t-line" />
              <p ref="btn" className="btn-discover">
                {this.props.cta}
              </p>
              <span ref="bLine" className="line b-line" />
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/wall/components/wall-wrapper-mobile/index.js